import React, { memo, useMemo } from 'react';
import { decode } from 'he';
import { useEngineInstance } from '@surveycake/react-logic-engine';
import { Header, Banner, Intro, SlateHtml } from 'app/shared/components';
import Start from './Start';

function SurveyHeader() {
  const engine = useEngineInstance();
  const { title, welcomebanner, welcometext, multiplePages } = useMemo(() => {
    const data = engine.getSurveyData();
    return {
      title: data.title,
      welcomebanner: data.welcomebanner,
      welcometext: data.welcometext,
      multiplePages: data.multiplePages
    };
  }, [engine]);
  const banner = welcomebanner ? (
    <Banner banner={welcomebanner} limitType="max" limitSize={400} />
  ) : (
    undefined
  );
  const intro = title ? (
    <Intro title={decode(title)}>
      {welcometext ? <SlateHtml html={welcometext} /> : undefined}
    </Intro>
  ) : (
    undefined
  );

  return (
    <Header banner={banner} intro={intro}>
      {multiplePages && <Start />}
    </Header>
  );
}

export default memo(SurveyHeader);
